import React from "react";
import axios from "axios";
import GatsbyConfig from "../../../gatsby-config.js";
import { saveData, validateRequired, validateEmail } from "../../utils/forms";
import { getInLocal, setInLocal, trackEvent } from "../../utils/app-helpers";

const { siteMetadata: config } = GatsbyConfig;

export default class NewsletterCallout extends React.Component {
  static MAILCHIMP_KEY = "f55a85e855f9c298bb5e765a0b4dc340-us1";
  static BLANK_FORM_DATA = {
    firstName: "",
    lastName: "",
    email: "",
  };

  constructor() {
    super();
    this.onInputChange = this.onInputChange.bind(this);
    this.subscribe = this.subscribe.bind(this);
    this.liveChecking = false;
    this.state = { isBusy: false };
  }

  getDataKeysToValidate() {
    const { trip } = this.props;
    const tripData = config.trips[trip];
    const validateDataKeys = Object.keys(NewsletterCallout.BLANK_FORM_DATA);

    if (!tripData.requireFirstNameForNewsletter)
      delete validateDataKeys[validateDataKeys.indexOf("firstName")];
    if (!tripData.requireLastNameForNewsletter)
      delete validateDataKeys[validateDataKeys.indexOf("lastName")];
    return validateDataKeys;
  }

  onInputChange() {
    const formEl = this.refs.form;

    this.data = saveData("lsg.newsletter-data", formEl);
    if (this.liveChecking) {
      validateRequired(
        "lsg.newsletter-data",
        this.getDataKeysToValidate(),
        formEl
      );
      validateEmail("lsg.newsletter-data", ["email"], formEl);
    }
  }

  subscribe(e) {
    e.preventDefault();
    const formEl = this.refs.form;
    const wrapperEl = this.refs.wrapper;

    if (
      !validateRequired(
        "lsg.newsletter-data",
        this.getDataKeysToValidate(),
        formEl
      ) ||
      !validateEmail("lsg.newsletter-data", ["email"], formEl)
    ) {
      this.liveChecking = true;
      return;
    }
    const { trip, analyticsLocation } = this.props;
    const tripData = config.trips[trip];
    const endpoint = process.env.GATSBY_ENDPOINT_NEWSLETTER;
    const { protocol, hostname, port } = window.location;
    const params = {
      ...this.data,
      trip,
      returnPathRoot: `${protocol}//${hostname}${
        port ? ":" + port : ""
      }/${trip}`,
      tripDates: tripData.dates,
      tripName: tripData.name,
      tripYear: tripData.year,
      tripRegion: tripData.region,
      tripVenue: tripData.venue,
      requestBrochureCategoryID: tripData.requestBrochureCategoryID,
    };
    let keyPairs = [];
    for (let key in params) {
      keyPairs.push(`${key}=${encodeURIComponent(params[key])}`);
    }
    wrapperEl.classList.remove("sent", "failed");
    this.setState({ isBusy: true });
    axios
      .post(`${endpoint}?${keyPairs.join("&")}`, {
        headers: config.axiosHeaders,
      })
      .then(function () {
        wrapperEl.classList.add("sent");
        formEl.reset();
        setInLocal("lsg.newsletter-data", NewsletterCallout.BLANK_FORM_DATA);
      })
      .catch(function () {
        wrapperEl.classList.add("failed");
      })
      .finally(
        function () {
          this.setState({ isBusy: false });
        }.bind(this)
      );

    trackEvent("Lead", {
      content_name: `${tripData.name} ${tripData.year} - ${analyticsLocation}`,
      value: 20,
      currency: "USD",
    });
  }

  render() {
    const { trip } = this.props;
    const { isBusy } = this.state;
    const tripData = config.trips[trip];
    const data = (this.data = getInLocal(
      "lsg.newsletter-data",
      true,
      NewsletterCallout.BLANK_FORM_DATA
    ));
    const { requireFirstName, requireLastName } = this.props;

    return (
      <div className="newsletter-callout" ref="wrapper">
        {isBusy ? (
          <div className="loader-mask">
            <p>Subscribing</p>
            <div className="loader" />
          </div>
        ) : (
          ""
        )}
        <div className="wrap">
          {trip ? (
            <div className="thanks">
              <h2>Thank You!</h2>
              <a
                className="btn btn-primary hide"
                href={`/files/Brochure-${tripData.name}${tripData.year}.pdf`}
              >
                <i className="fa fa-download" />
                Download Brochure
              </a>
            </div>
          ) : (
            ""
          )}
          <form method="POST" ref="form">
            <h2>
              Join Our
              <br /> Mailing List
            </h2>
            <p className="instructions">
              Enter your name &amp; email address for Love Song promotions &amp;
              updates.
            </p>
            {requireFirstName && requireLastName ? (
              <div>
                <p className="field field-split field-split-40-60">
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    autoComplete="given-name"
                    onChange={this.onInputChange}
                    defaultValue={data.firstName}
                    aria-label="Name"
                  />
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    autoComplete="family-name"
                    onChange={this.onInputChange}
                    defaultValue={data.lastName}
                    aria-label="Last Name"
                  />
                </p>
                <p className="field field-split split-button">
                  <input
                    type="text"
                    name="email"
                    placeholder="Email"
                    autoComplete="email"
                    onChange={this.onInputChange}
                    defaultValue={data.email}
                    aria-label="Email"
                  />
                  <button className="btn-primary" onClick={this.subscribe}>
                    Submit
                  </button>
                </p>
              </div>
            ) : (
              <p className="field field-split field-split-50-50 split-button">
                {requireFirstName ? (
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    autoComplete="given-name"
                    onChange={this.onInputChange}
                    defaultValue={data.firstName}
                    aria-label="Name"
                  />
                ) : (
                  ""
                )}
                {requireLastName ? (
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    autoComplete="family-name"
                    onChange={this.onInputChange}
                    defaultValue={data.lastName}
                    aria-label="Last Name"
                  />
                ) : (
                  ""
                )}
                <input
                  type="text"
                  name="email"
                  placeholder="Email"
                  autoComplete="email"
                  onChange={this.onInputChange}
                  defaultValue={data.email}
                  aria-label="Email"
                />
                <button className="btn-primary" onClick={this.subscribe}>
                  Submit
                </button>
              </p>
            )}
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/newsletter-callout.js